export default "__VITE_ASSET__BO0v91Ra__"